import React from "react";

import AffiliateCard from "../Cards/AffiliateCard";

export default function AffiliatesGridSlider({affiliates}) {


  return (
    <div className="row affiliates-map-section__grid-slider">
      {
          affiliates?.nodes.map(affiliate => {
            return (
              <div className="col-lg-3">
                <AffiliateCard
                  key={affiliate.headline}
                  affiliatePost={affiliate}
                />
              </div>  
            )     
          })
      }
    </div>
  )
}